/*
 * Helper function to make window.location.href testable
 * ####### Usage ######
 * cy.window().then(win => {
 *     cy.stub(win.LocationHelper, 'redirectTo').as('redirectTo');
 * });
 */
export const LocationHelper = {
    redirectTo: (url: string) => {
        window.location.href = url;
    },
};
// exposed this only when testing via cypress so function can be stubbed
if (typeof window !== 'undefined' && window.Cypress) {
    window.LocationHelper = LocationHelper;
}
